import { useAccount, useBalance } from '@lair-finance/wagmi'
import { Address } from 'viem'
import { isNativeToken } from '@/shared/lib/utils/token.ts'
import { formatEther } from 'ethers'

export const useTokenBalance = ({
  chainId,
  tokenAddress,
  watch,
  enabled,
}: {
  chainId?: number
  tokenAddress?: Address
  watch?: boolean
  enabled?: boolean
}) => {
  const account = useAccount()
  const { data, ...states } = useBalance({
    chainId: chainId || account.chainId,
    address: account.address,
    token: isNativeToken(tokenAddress!) ? undefined : tokenAddress,
    watch,
    query: { enabled },
  })

  const balanceWei = data ? data.value : undefined
  const balance = balanceWei ? formatEther(balanceWei) : undefined

  return { balanceWei, balance, ...states }
}
